import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/text/TextStyleOptions";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {Atreyu} from "../Fonts";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {OktoberfestGameAssets} from "../OktoberfestGameAssets";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";

export class OktoberfestIntroConfig implements GameIntroViewConfig {
    colors: GameIntroColors = {
        slideShowColors: {
            backgroundColor: 0x000000, //Default 0x000000
            backgroundAlpha: 0, //Default 0.4
            bulletColor: 0xffffff, //Default 0xffffff

        },
        stampColor: 0xFFFFFF
    };

    stampConfig: StampConfig = {};
    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];

    public init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/introSplash/desktop/desk_splash.jpg");
        imgLoader.add("prost", "resources/images/introSplash/desktop/gretchen_hansi2.png");
        imgLoader.add("bier", "resources/images/introSplash/desktop/bier-scatters.png");
        imgLoader.add("party", "resources/images/introSplash/desktop/w.png");

        const fontLoader = new FontLoader(NolimitApplication.resourcePath);
        fontLoader.add(Atreyu.REGULAR);

        return Promise.all([fontLoader.load(), imgLoader.load()]).then(() => {
            this.initGraphics();
            return this;
        });
    }

    public onResize(): void {
        let resizeElement;
        for (let i = 0; i < this.pages.length; i++) {
            if (this.pages[i].name === "OktoberfestTripleIconPage") {
                resizeElement = this.pages[i];
            }
        }
        if (resizeElement) {
            if (NolimitApplication.isLandscape) {
                resizeElement!.children[0].position.set(-300, 0);
                resizeElement!.children[2].position.set(300, 0);
            } else {
                resizeElement!.children[0].position.set(-260, 0);
                resizeElement!.children[2].position.set(260, 0);
            }
        }
    }

    private initGraphics() {
        // Adding Background Graphic On Full Page
        const bg: PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        bg.anchor.set(0.5);
        bg.tint = 0x1a6c78;
        bg.width = 1680;
        bg.height = 1680;
        bg.position.set(0);

        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);

        this.background = new PIXI.Container();
        this.background.name = "introBgContainer";
        this.background.addChild(bg, bgSprite);

        this.borderTop = new PIXI.Container();
        this.borderBottom = new PIXI.Container();
        this.logo = new PIXI.Container();

        this.pages = [
            new OktoberfestTripleIconPage()
        ];
    }
}

export class OktoberfestTripleIconPage extends SlideShowPage {
    private _scatterImg: PIXI.Sprite;
    private _scatterText: PIXI.Text;
    private _scatterContainer: PIXI.Container;

    private _prostImg: PIXI.Sprite;
    private _prostText: PIXI.Text;
    private _prostContainer: PIXI.Container;

    private _wildImg: PIXI.Sprite;
    private _wildText: PIXI.Text;
    private _wildContainer: PIXI.Container;
    private _introDesktopStyleOptions: TextStyleOptions = {
        fontFamily: "Atreyu",
        fontSize: "36px",
        fill: "#FFFFFF",
        stroke: "#000000",
        strokeThickness: 2
    };

    constructor() {
        super();
        this.onIntroImagesLoaded();
        this.name = "OktoberfestTripleIconPage";
    }

    public onIntroImagesLoaded() {
        this._scatterImg = new PIXI.Sprite(ImgLoader.getImgTexture("bier"));
        this._scatterImg.anchor.set(0.5);
        this._scatterText = new PIXI.Text("Bierspins", this._introDesktopStyleOptions);
        this._scatterText.anchor.set(0.5);
        this._scatterText.position.set(0, 100);

        this._prostImg = new PIXI.Sprite(ImgLoader.getImgTexture("prost"));
        this._prostImg.anchor.set(0.5);
        this._prostImg.scale.set(0.9);
        this._prostText = new PIXI.Text("Prost Spins", this._introDesktopStyleOptions);
        this._prostText.anchor.set(0.5);
        this._prostText.position.set(0, 190);
        this._prostText.name = "_prostText";

        this._wildImg = new PIXI.Sprite(ImgLoader.getImgTexture("party"));
        this._wildImg.anchor.set(0.5);
        this._wildText = new PIXI.Text("Party Spins", this._introDesktopStyleOptions);
        this._wildText.anchor.set(0.5);
        this._wildText.position.set(0, 100);

        this._scatterContainer = new PIXI.Container();
        this._prostContainer = new PIXI.Container();
        this._wildContainer = new PIXI.Container();

        this._scatterContainer.addChild(this._scatterText, this._scatterImg);
        this._prostContainer.addChild(this._prostText, this._prostImg);
        this._wildContainer.addChild(this._wildText, this._wildImg);

        this.addChild(this._scatterContainer, this._prostContainer, this._wildContainer);
    }
}